module.exports = __webpack_public_path__ + "static/img/zygkbg.0ebf9a2c.png";